// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"B_TheComp__Y71xS","items":"B_items__kPPUv","ef-box":"B_ef-box__sxBQz","col":"B_col__0ZDsJ"};